(function () {
	'use strict';

	angular.module('smb-app')
		.factory('smbContentTypeGroupConfigService',
		[
			'$http',
			'pxUriPathService',
			ContentTypeGroupConfigService
		]);

	/**
	 * @ngdoc service
	 * @name smb-app.smbContentTypeGroupConfigService
	 * 
	 * @description
	 * A service that exposes methods for creating and updating content type groups.
	 */
	function ContentTypeGroupConfigService($http, pxUriPathService) {

		return {
			/**
			 * @ngdoc method
			 * @name smbContentTypeGroupConfigService#createContentTypeGroup
			 * @methodOf smb-app.smbContentTypeGroupConfigService
			 * @kind function
			 * 
			 * @description
			 * Creates a new content type group in the system.
			 * 
			 * @param {Object} group An object representing the content type group to create
			 *
			 * @returns {Promise} A promise that resolves to the newly created content type group
			 */
			createContentTypeGroup: createContentTypeGroup,

			/**
			 * @ngdoc method
			 * @name smbContentTypeGroupConfigService#createContentTypeGroup
			 * @methodOf smb-app.smbContentTypeGroupConfigService
			 * @kind function
			 * 
			 * @description
			 * Saves changes made to an existing content type group
			 * 
			 * @param {Object} group An object that represents an existing content type group
			 * 
			 * @returns {Promise} A promise that resolves to the content type group that was changed
			 */
			editContentTypeGroup: editContentTypeGroup
		};

		function createContentTypeGroup(group) {
			return $http.post(pxUriPathService.resolvePath('/libraries'), group)
				.then(function (res) { return res.data; });
		}

		function editContentTypeGroup(group) {
			return $http.patch(pxUriPathService.resolvePath('/libraries/' + group.LibraryId), group)
				.then(function(res) {
					return res.data;
				});
		}	
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/services/contentConfigServices/contentTypeGroupConfigService.js
// module id = 136
// module chunks = 1